export enum SpecialOrderRequestFileType {
  print_file = "print_file",
  type_file = "type_file",
}
